import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32 pb-20" data-id="element-86">
      <div className="max-w-[1600px] w-full mx-auto px-6 md:px-12 flex flex-col items-center text-center" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 2.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60vw] h-[60vw] md:w-[40vw] md:h-[40vw] rounded-full blur-[120px] opacity-20 pointer-events-none" style={{
        background: 'radial-gradient(circle, var(--gold) 0%, transparent 70%)'
      }} data-id="element-88" />

        <div className="relative z-10 flex flex-col items-center mt-20 md:mt-0" data-id="element-89">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1.8,
          delay: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }} className="serif text-5xl md:text-7xl lg:text-8xl xl:text-[7rem] leading-[1.1] text-charcoal max-w-5xl" data-id="element-90">
            תכשיט הוא רגע
            <br data-id="element-91" />
            שנשאר לנצח
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1.5,
          delay: 1,
          ease: [0.16, 1, 0.3, 1]
        }} className="label-tiny text-charcoal/60 mt-12 md:mt-16 max-w-md" data-id="element-92">
            אמנות צורפות עילית. עבודת יד מוקפדת מלב תל אביב.
          </motion.p>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1.5,
          delay: 1.4,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-16 md:mt-24" data-id="element-93">
            <a href="#collections" className="group relative inline-flex items-center justify-center px-10 py-4 border border-charcoal/20 hover:border-gold transition-colors duration-700 overflow-hidden" data-id="element-94">
              <span className="relative z-10 label-tiny text-charcoal group-hover:text-gold transition-colors duration-700" data-id="element-95">
                גלו את הקולקציה
              </span>
              <div className="absolute inset-0 bg-gold/5 translate-y-full group-hover:translate-y-0 transition-transform duration-700 ease-[0.16,1,0.3,1]" data-id="element-96" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}